import React from "react";
import { IoCopyOutline } from "react-icons/io5";
import ATMCopyToClipboard from "src/components/UI/atoms/ATMCopyToClipboard/ATMCopyToClipboard";
import SideNavLayout from "src/components/layouts/SideNavLayout/SideNavLayout";
import { isCheckActionsPermission } from "src/helpers/userAccessFun";
import {
  UserModuleActionTypes,
  UserModuleNameTypes,
} from "src/models/userAccess/UserAccess.model";
import ATMPageHeader from "src/components/UI/atoms/ATMPageHeader/ATMPageHeader";
import ATMPagination from "src/components/UI/atoms/ATMPagination/ATMPagination";
import ATMMenu from "src/components/UI/atoms/ATMMenu/ATMMenu";
type Props = {
  onAddNew: any;
  getActionOptions: any;
  rows: any;
  paginationProps: {
    isTableLoading: boolean;
    totalItems: number;
    page: number;
    rowsPerPage: number;
    searchValue: string;
    setPage: (newPage: number) => void;
    setRowsPerPage: (newLimit: number) => void;
    setSearchValue: (newValue: string) => void;
  };
};

const ResourceListing = ({
  onAddNew,
  rows,
  getActionOptions,
  paginationProps: {
    isTableLoading,
    totalItems,
    page,
    rowsPerPage,
    searchValue,
    setPage,
    setRowsPerPage,
    setSearchValue,
  },
}: Props) => {
  const [isCopied, setIsCopied] = React.useState(false);

  return (
    <SideNavLayout>
      <div className="flex flex-col gap-6 p-4 ">
        {/* Page Header */}
        <div className="">
          <ATMPageHeader
            pageTitle="Resources"
            searchValue={searchValue}
            onSearchChange={setSearchValue}
            hideAddButton={
              !isCheckActionsPermission({
                moduleName: UserModuleNameTypes.RESOURCE,
                actionName: UserModuleActionTypes.ADD,
              })
            }
            buttonProps={{
              btnName: "Add New",
              onClick: onAddNew,
            }}
          />
        </div>

        <div className="grid grid-cols-6 gap-6 mt-3">
          {isCheckActionsPermission({
                moduleName: UserModuleNameTypes.RESOURCE,
                actionName: UserModuleActionTypes.LIST,
              }) && ( isTableLoading ? (
            Array(6)
              .fill(0)
              .map((_, index) => {
                return (
                  <div key={index} className="animate-pulse  h-[150px] p-2">
                    <div className="h-full rounded bg-slate-200"> </div>
                  </div>
                );
              })
          ) : rows?.length ? (
            rows?.map((el: any, ind: any) => {
              const options = getActionOptions(el?._id);
              return (
                <div key={ind} className="px-2 border-2 rounded border-slate-200">
                  {el?.type === "IMAGE" ? (
                    <div>
                      <div className="flex items-center justify-end p-0">
                        <ATMCopyToClipboard
                          tooltipTitle={isCopied ? "Copied Url" : "Copy Url"}
                          copyText={el?.imageUrl}
                          onCopy={() => {
                            setIsCopied(true);
                            setTimeout(() => {
                              setIsCopied(false);
                            }, 1000);
                          }}
                        >
                          <IoCopyOutline size="1.1em" />
                        </ATMCopyToClipboard>
                        <ATMMenu
                          iconSize={20}
                          options={options}
                          orientation="vertical"
                        />
                      </div>{" "}
                      <img
                        className="h-[150px ] w-[300px]"
                        src={el?.imageUrl}
                        alt={el?.title}
                      />
                      <div className="flex items-center justify-between mt-2">
                        <span className="text-[16px]  font-semibold">
                          {el?.title}{" "}
                        </span>
                      </div>{" "}
                    </div>
                  ) : (
                    <div className="h-[150px]">
                      <div className="flex items-center justify-between mt-2">
                        <span className="text-[16px]  font-semibold">
                          {el?.title}{" "}
                        </span>

                        <div className="flex items-center">
                          <ATMCopyToClipboard
                            tooltipTitle={isCopied ? "Copied Url" : "Copy Url"}
                            copyText={el?.description}
                            onCopy={() => {
                              setIsCopied(true);
                              setTimeout(() => {
                                setIsCopied(false);
                              }, 1000);
                            }}
                          >
                            <IoCopyOutline size="1.1em" />
                          </ATMCopyToClipboard>
                          <ATMMenu
                            iconSize={20}
                            options={options}
                            orientation="vertical"
                          />
                        </div>
                      </div>{" "}
                    </div>
                  )}
                </div>
              );
            })
          ) : (
            <div className="flex items-center justify-center w-full py-5 text-xl font-semibold text-red-800">
              No Data Found
            </div>
          ))}
        </div>
        <div className="flex justify-end p-4 py-2">
          <ATMPagination
            page={page}
            rowsPerPage={rowsPerPage}
            onPageChange={setPage}
            onRowsPerPageChange={setRowsPerPage}
            rowCount={totalItems}
            rows={rows}
          />
        </div>
      </div>
    </SideNavLayout>
  );
};

export default ResourceListing;
